import React from 'react'

import { Drawer, DrawerAction, DrawerActions } from '@acorns/web-components'
import { useRemoteStrings } from '@acorns/web-utils'
import styled from 'styled-components'

import { useDirectDepositDisclosureTracking } from './events'

export const StyledDisclosureContent = styled.div`
  font-size: 14px;
  line-height: 22px;
`

export type Props = {
  showDisclosureDrawer: boolean
  closeDisclosureDrawer: () => void
  disclosureDrawerBackButtonPress?: () => void
  goToPinwheel: () => void
  isLoadingDDLinkData: boolean
}

export const DisclosureDrawer: React.FC<Props> = (props: Props) => {
  useDirectDepositDisclosureTracking(props.showDisclosureDrawer)
  const { getRemoteString } = useRemoteStrings()

  const draweractions: DrawerAction[] = [
    {
      label: getRemoteString({
        key: 'spend.direct_deposit.drawer.terms.cta.primary',
      }),
      handler: props.goToPinwheel,
      testId: 'done_button',
      disabled: props.isLoadingDDLinkData,
    },
  ]
  if (props.disclosureDrawerBackButtonPress) {
    draweractions.unshift({
      label: getRemoteString({
        key: 'spend.direct_deposit.drawer.terms.cta.secondary',
      }),
      handler: props.disclosureDrawerBackButtonPress,
      testId: 'disclosure_back_button',
      secondary: true,
    })
  }

  return (
    <Drawer
      isOpen={props.showDisclosureDrawer}
      onClose={props.closeDisclosureDrawer}
      title={getRemoteString({
        key: 'spend.direct_deposit.drawer.terms.title',
      })}
    >
      <StyledDisclosureContent>
        {getRemoteString({
          key: 'spend.direct_deposit.drawer.terms.body.pinwheel',
        })}
      </StyledDisclosureContent>
      <DrawerActions actions={draweractions} />
    </Drawer>
  )
}
